var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.getStatus),function(status,index){return _c('chip-component',{key:index,staticClass:"mb-1",attrs:{"reason":_vm.getReason,"payload":status,"add-class":[]}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }